'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';
import categoryFilters from '../../components/filters/category';
import characteristicFilters from '../../components/filters/characteristic';

export class ProductController {

  closeWindow: Function;
  deleteCharRow: Function;
  deleteProductRow: Function;

  api;
  charsApi;
  data;
  options;
  charsOptions;
  product;
  products;
  productSelected;
  charSelected;
  characteristics;

  /*@ngInject*/
  constructor($scope, Storage, WindowService, $q, AlertMessageFactory) {
    this.Storage  = Storage;
    this.scope    = $scope;
    this.Promise  = $q.defer;

    this.closeWindow = WindowService.delItem;
    this.scope.deleteProductRow  = this.deleteProductRow.bind(this);
    this.scope.deleteCharRow     = this.deleteCharRow.bind(this);
    this.scope.searchProductById = this.searchProductById.bind(this);

    this.error       = AlertMessageFactory.error;
    this.success     = AlertMessageFactory.success;
  }

  $onInit() {
    this.product         = this.data.product || {kit: [], characteristics: [], categoryId: this.data.category._id};
    this.products        = this.Storage.getProducts();
    this.characteristics = this.Storage.getCharacteristics();

    (this.product.kit || []).forEach((item, index) => {
      var child = this.searchProductById(item.productId);
      if(child){
        this.product.kit[index].name       = child.name;
        this.product.kit[index].categoryId = child.categoryId;
      }
    });

    this.options = {
      primaryKey: '_id',
      enableCellEdit: true,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      rowEditWaitInterval: -1,
      noUnselect: true,
      data: this.product.kit,
      onRegisterApi: (gridApi) => {

        this.api = gridApi;

        gridApi.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
          var deferred = this.Promise();
          setTimeout(() => {
            gridApi.rowEdit.setRowsClean([rowEntity]);
            deferred.resolve();
          }, 100);
          return deferred.promise;
        });
      },
      columnDefs: [{
        displayName: '#',
        field: '_id',
        visible: false,
      }, {
        displayName: 'Категоря',
        field: 'categoryId',
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderCategory"></div>',
        cellEditableCondition: function(){ return false; },
      }, {
        displayName: 'Товар',
        field: 'name',
        cellEditableCondition: function(){ return false; },
      }, {
        displayName: 'Кол-во',
        field: 'count',
        width: 50,
        type: 'number', 
      }, {
        displayName: 'Стоимость',
        field: 'amount',
        width: 150,
        type: 'number', 
        cellTemplate: '<span style="padding:5px;">{{grid.appScope.searchProductById(row.entity.productId).amount | currency}}</span>',
        cellEditableCondition: function(){ return false; },
      }, {
        displayName: 'Рабочему',
        field: 'payWorker',
        width: 50,
        type: 'boolean', 
        cellTemplate: '<span style="padding:5px;">{{row.entity.payWorker ? "Да" : ""}}</span>',
      }, {
        displayName: '#',
        field: 'status',
        width: 50,
        cellTemplate: '<span style="padding:5px;"><a href="javascript:;" ng-click="grid.appScope.deleteProductRow(row)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a></span>',
        cellEditableCondition: function(){ return false; },
      }]
    };

    return this.Storage.loadCategoryCharacteristics(this.product.categoryId)
      .then((categoryCharacteristics) => {

        if( ! this.product.characteristics){
          this.product.characteristics = [];
        }

        (categoryCharacteristics || []).forEach(item => {
          var inProduct = (this.product.characteristics || []).filter(row => row.charId == item.carachteristicId).length > 0;
          if( ! inProduct){
            this.product.characteristics.push({
              charId: item.carachteristicId,
              value: item.defaultValue || '',
            });
          }
        });
        // this.product.characteristics

        this.charsOptions = {
          primaryKey: '_id',
          enableCellEdit: true,
          enableRowSelection: true,
          enableRowHeaderSelection: false,
          multiSelect: false,
          modifierKeysToMultiSelect: false,
          rowEditWaitInterval: -1,
          noUnselect: true,
          data: this.product.characteristics,
          onRegisterApi: (gridApi) => {

            this.charsApi = gridApi;

            gridApi.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
              var deferred = this.Promise();
              setTimeout(() => {
                gridApi.rowEdit.setRowsClean([rowEntity]);
                deferred.resolve();
              }, 100);
              return deferred.promise;
            });
          },
          columnDefs: [{
            displayName: '#',
            field: '_id',
            visible: false,
          }, {
            displayName: 'Характеристика',
            field: 'charId',
            cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderCharacteristic"></div>',
            cellEditableCondition: function(){ return false; },
          }, {
            displayName: 'Значение',
            field: 'value',
            width: 50
          }, {
            displayName: '#',
            field: 'status',
            width: 50,
            cellTemplate: '<span style="padding:5px;"><a href="javascript:;" ng-click="grid.appScope.deleteCharRow(row)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a></span>',
            cellEditableCondition: function(){ return false; },
          }]
        };
      });
  }

  save() {
    return this.Storage.saveProduct(this.product)
      .then(() => this.close())
      .catch(err => console.error(err));
  }

  close() {
    this.closeWindow(this.data.id);
  }

  deleteProductRow(row) {
    var i = this.product.kit.forEach((item, index) => {
      if(row.entity.productId == item.productId){
        this.product.kit.splice(index, 1);
      }
    });
  }

  deleteCharRow(row){
    var i = this.product.characteristics.forEach((item, index) => {
      if(row.entity.charId == item.charId){
        this.product.characteristics.splice(index, 1);
      }
    });
  }

  onCharSelect() {
    if( ! this.charSelected){
      return;
    }

    var sel = this.product.characteristics.filter(row => {
      return row.charId == this.charSelected._id;
    }).shift();

    if(sel){
      this.charsApi.selection.selectRow(sel);
      this.charsApi.edit.raise.beginCellEdit(sel, 'value');
      this.charSelected = undefined;
      return;
    }

    this.product.characteristics.push({
      charId: this.charSelected._id,
      value: '',
    });

    this.charSelected = undefined;
  }

  onProductSelect() {
    if( ! this.productSelected){
      return;
    }

    var sel = this.product.kit.filter(row => {
      return row.productId == this.productSelected._id;
    }).shift();

    if(sel){
      this.api.selection.selectRow(sel);
      this.api.edit.raise.beginCellEdit(sel, 'count');
      this.productSelected = undefined;
      return;
    }

    this.product.kit.push({
      productId: this.productSelected._id,
      categoryId: this.productSelected.categoryId,
      name: this.productSelected.name,
      count: 1,
      amount: this.productSelected.amount
    });

    this.productSelected = undefined;
  }

  searchProductById(id) {
    return this.products
      .filter(product => product._id == id)
      .shift();
  }
}



export default angular.module('storageApp.product', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    categoryFilters,
    characteristicFilters,
  ])
  .component('product', {
    bindings: {data: '='},
    template: require('./product.html'),
    transclude: true,
    controller: ProductController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/product/product.component.js